import { createSlice } from "@reduxjs/toolkit";

export const langSlice = createSlice({ //reducers for both hours in global state
    name: 'lang',
    initialState:{},
    reducers: {
        setLang: (currentState, action) => {
            return action.payload
        }
    }
});